import { FC } from 'react';
import { IWedding_Website_Section_TextField } from '@bridebook/models/source/models/Weddings.types';
import { WebsiteTileVariant } from '@bridebook/web/components/wedding-website/view-mode/partials/tile-component/wedding-website-tile-component';
import { WeddingWebsiteTextField } from '@bridebook/web/components/wedding-website/view-mode/website-view/tiles/wedding-website-text-field';
import { Palettes } from '@bridebook/web/lib/wedding-website/types';
import { shouldShowWebsiteSection } from '@bridebook/web/lib/wedding-website/utils/should-show-website-section';

interface IProps {
  title: string;
  palette: Palettes;
  variant: WebsiteTileVariant;
  section: IWedding_Website_Section_TextField;
}

export const WeddingWebsiteOurStory: FC<IProps> = ({ title, palette, variant, section }) => {
  if (!shouldShowWebsiteSection(section)) {
    return null;
  }

  return (
    <WeddingWebsiteTextField
      variant={variant}
      palette={palette}
      title={title}
      sectionName={section.name}>
      {section.data.value}
    </WeddingWebsiteTextField>
  );
};
